<template>
    <div>
        <template v-if="chargeable">
            <font-awesome-icon icon="coins" fixed-width/>
            <span>
                {{$t('menu.payment')}}
        </span>
        </template>
        <template v-else>
            <font-awesome-icon icon="id-card" fixed-width/>
            <span>
                {{$t('menu.contactPerson')}}
            </span>
        </template>
    </div>
</template>
<script>
export default {
    name: 'MenuItemPayment',
    computed: {
        chargeable() {
            return this.$store.getters["registration/chargeable"]
        }
    }
}
</script>
